import { MappingEntity } from '../../abstract-mapping-entity';
import { ICreationRuleEntity } from '../interface-creation-rule-entity';

/**
 * çåè§åå®ä½ç±»
 */
export class AifCreationRuleEntity extends MappingEntity implements ICreationRuleEntity {

}